import { initializeApp } from "firebase/app";
import {
  getAnalytics,
  isSupported as analyticsSupported,
} from "firebase/analytics";
import { getFunctions, connectFunctionsEmulator } from "firebase/functions";

// Firebase configuration pulled from environment variables.
// Make sure corresponding keys in your .env file are prefixed with VITE_.
const firebaseConfig = {
  apiKey: import.meta.env.VITE_API_KEY,
  authDomain:
    import.meta.env.VITE_AUTH_DOMAIN ?? "vetriaai-mvp.firebaseapp.com",
  projectId: import.meta.env.VITE_PROJECT_ID ?? "vetriaai-mvp",
  storageBucket:
    import.meta.env.VITE_STORAGE_BUCKET ?? "vetriaai-mvp.appspot.com",
  messagingSenderId: import.meta.env.VITE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_APP_ID,
  measurementId: import.meta.env.VITE_MEASUREMENT_ID,
};

// Initialize Firebase
export const firebaseApp = initializeApp(firebaseConfig);

// Initialize Functions with region
export const functions = getFunctions(firebaseApp, 'us-central1');

// Connect to emulator in development if needed
// Uncomment the following line if you're using Firebase emulator
// if (import.meta.env.DEV) {
//   connectFunctionsEmulator(functions, "localhost", 5001);
// }

// Initialise Analytics (only when available – it fails on some platforms like SSR)
export let firebaseAnalytics: ReturnType<typeof getAnalytics> | undefined;
if (typeof window !== "undefined") {
  analyticsSupported().then((supported) => {
    if (supported) {
      firebaseAnalytics = getAnalytics(firebaseApp);
    }
  });
}

// Secondary Firebase app for admin user creation
// This allows admins to create new users without affecting their own auth state
let secondaryApp: ReturnType<typeof initializeApp> | null = null;

export const getSecondaryApp = () => {
  if (!secondaryApp) {
    secondaryApp = initializeApp(firebaseConfig, "Secondary");
  }
  return secondaryApp;
};
